import { init as initApm } from '@elastic/apm-rum'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ThemeProvider } from '@mui/material/styles'
import { store } from './redux/store'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { theme } from './styles/theme'
import { CssBaseline } from '@mui/material'
import { QueryClient, QueryClientProvider } from 'react-query'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import './index.css'
import ScrollToTop from './components/ScrollToTop'

initApm({
  serviceName: 'GRC Front End',
  serverUrl: 'https://51.178.141.200:8200',
  environment: 'DEV',
})

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <Suspense fallback={<div>Loading translations...</div>}>
      <BrowserRouter
        future={{
          // Off: this wraps route updates in startTransition. History still
          // changes the URL immediately, but React keeps the previous page
          // (missions) when the next lazy route suspends or an in-flight
          // missions fetch interrupts the transition.
          v7_startTransition: false,
          v7_relativeSplatPath: true,
        }}
      >
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <QueryClientProvider client={queryClient}>
            <I18nextProvider i18n={i18n}>
              <ScrollToTop />
              <App />
            </I18nextProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Suspense>
  </Provider>
)
